<template>
  <div class="ne-node-country nkn-explorer-card-shadow">
    <div>
      <span class="rank">{{$t('network.title.rank')}}</span>
      <span class="title name">{{$t('network.title.country')}}</span>
      <span class="percent">{{$t('network.title.nodes')}}</span>
    </div>
    <div v-for="(country, idx) in countries" :key="idx">
      <span class="rank">{{idx + 1}}</span>
      <span class="flag">
        <img :src="'/static/img/flags-normal/' + country.code + '.png'" />
      </span>
      <span class="name">{{country.name}}</span>
      <span class="percent">{{count[idx]}} ({{getPercent(count[idx])}})</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ne-node-country",
  props: ["geoSummary"],
  data() {
    return {
      countries: [],
      count: [],
      totalCount: 0
    };
  },
  mounted() {
      //console.log("nknNodeCountry mounted...");
      if(this.geoSummary.length > 0) {
          this.updateChart();
      }
  },
  methods: {
    updateChart() {
      this.countries = [];
      this.count = [];
      this.totalCount = 0;

      for (let i = this.geoSummary.length - 1; i > 0; i--) {
        let code = this.geoSummary[i].Cities[0].CountryCode.toLowerCase();
        if ("hk" === code || "tw" === code) {
          continue;
        }
        this.countries.push({
          name: this.geoSummary[i].Country,
          code: this.geoSummary[i].Cities[0].CountryCode.toLowerCase()
        });
        this.count.push(this.geoSummary[i].Count);
        this.totalCount += this.geoSummary[i].Count;
      }
    },
    getPercent(count) {
      return ((count * 100) / this.totalCount).toFixed(2) + "%";
    }
  },
  watch: {
    geoSummary() {
      this.updateChart();
    }
  }
};
</script>

<style scoped>
.ne-node-country {
  /* margin-top: 20px; */
  border: 1px solid #ddd;
  box-shadow: rgba(0, 0, 0, 0.12) 0 2px 6px, rgba(0, 0, 0, 0.24) 0 1px 2px;
}
.ne-node-country .flag img {
  width: 25px;
  border: 1px solid #dddddd;
}
@media screen and (min-width: 768px) {
  .ne-node-country {
    border-top: none;
  }
}
.ne-node-country .rank {
  width: 40px;
  margin-right: 5px;
  text-align: center;
}

.ne-node-country .name {
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
  overflow: hidden;
  width: 70px;
}

.ne-node-country .title.name {
  width: 100px;
}

.ne-node-country {
  line-height: 30px;
  padding: 10px;
  /* padding-left: 30px; */
  background: #ffffff;
  /* margin-bottom: 20px; */
}

.ne-node-country > div > span {
  padding-right: 10px;
  display: inline-block;
}

.ne-node-country .flag {
  padding-right: 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/plugins/nknNodeCountry.vue